class MattressCloseup extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.isConnected) {
      this.cacheElements();
    }
  
    if (this.isConnected && !this.initialized) {
      this.initialized = true;

      this.initSwiper();
      this.initTabs();
    }
  }

  /**
   * Used to reinitialize this section, helpful for when contents change.
   */
  reinit() {
    this.detachListeners();
    this.destroySwiper();
    this.cacheElements();
    this.initSwiper();
    this.initTabs();
  }
  
  cacheElements() {
    this.tabs = this.querySelectorAll('.MCTabList__Tab');
    this.tablist = this.querySelector('.MCTabList');
    this.slides = this.querySelectorAll('.MatCloseupSlide');
    this.swiperWrapper = this.querySelector('.MattressCloseupSwiper .swiper-wrapper');

    // Bind functions
    this.onTablistClick = this.onTablistClick.bind(this);
    this.updateTablistSelectedBar = this.updateTablistSelectedBar.bind(this);
    this.debouncedUpdateTabSelectedBar =
      NUtils.debounce(this.updateTablistSelectedBar, 100);
  }

  initTabs() {
    this.tabs.forEach(tab => {
      if (tab.getAttribute('aria-selected') === 'true') {
        this.waitForStylesheetAndLoadTab(tab);
      }
    });

    this.tablist.addEventListener('click', this.onTablistClick);

    // Update tablist 'selected bar' on media query change
    window.addEventListener('resize', this.debouncedUpdateTabSelectedBar);

    // Update again on load to account for when the fonts load in
    window.addEventListener('load', this.updateTablistSelectedBar);
  }

  detachListeners() {
    this.tablist.removeEventListener('click', this.onTablistClick);
    window.removeEventListener('resize', this.debouncedUpdateTabSelectedBar);
    window.removeEventListener('load', this.updateTablistSelectedBar);
  }

  onTablistClick(e) {
    if (e.target.matches('.MCTabList__Tab')) {
      this.selectTab(e.target);
    }
  }

  waitForStylesheetAndLoadTab(tab) {
    if (document.readyState === 'complete') {
      this.selectTab(tab);
      this.swiper.update();
    } else {
      window.addEventListener('load', () => {
        this.selectTab(tab);
        this.swiper.update();
      });
    }
  }

  selectTab(tab, updateActiveSlide = true) {
    if (updateActiveSlide) {
      const category = tab.dataset.category;
      const matchingSlideIndex =
        Array.from(this.slides).findIndex(s => s.dataset.category === category);
      this.swiper.slideTo(matchingSlideIndex, 300, false /* don't run callbacks */);
    }
    
    // Update aria selected
    this.tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
    tab.setAttribute('aria-selected', 'true');

    this.updateTablistSelectedBar();
  }

  updateTablistSelectedBar() {
    const bar = this.tablist.querySelector('.MCTabList__SelectedBarInner');
    const selectedTab =
      this.tablist.querySelector('.MCTabList__Tab[aria-selected="true"]');
    const tablistXPos = this.tablist.getBoundingClientRect().left;
    const selectedTabRect = selectedTab.getBoundingClientRect();
    
    const barNewXPos = selectedTabRect.left - tablistXPos;
    const barNewWidth = selectedTabRect.width;
    bar.style.left = barNewXPos + 'px';
    bar.style.width = barNewWidth + 'px';
  }

  initSwiper() {
    this.swiper = new Swiper('.MattressCloseupSwiper.swiper-container', {
      slidesPerView: 1,
      roundLengths: true,
      navigation: {
        nextEl: '.MattressCloseupSwiper__Nav .swiper-button-next',
        prevEl: '.MattressCloseupSwiper__Nav .swiper-button-prev',
      },
      pagination: {
        el: '.MattressCloseupSwiper__Pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {},
      on: {
        slideChangeTransitionStart: () => {
          const activeTab = this.tabs[this.swiper.activeIndex];
          this.selectTab(activeTab, false /* don't update slider again */);
        },
      },
    });
  }

  destroySwiper() {
    this.swiper && this.swiper.destroy();
  }
}

customElements.define('mattress-closeup', MattressCloseup);